import { ControlProperty } from '../../../../../common/models';
import { StatusLabelColor } from '../../../../../common/constants';
import { DraggableFilterType } from '../../../../constants';
import { PartnerType as PartnerTypeAlias } from '../../partner';

export enum ApiConnectionAssignmentType {
  Organization = 'ORGANIZATION',
  Partner = 'PARTNER',
}

export enum ApiConnectionType {
  EDI = 'EDI',
  LSP = 'LSP',
  LISA = 'LISA',
  MIDEA = 'MIDEA',
  SAP = 'SAP',
  SHIPPEO = 'SHIPPEO',
  External = 'EXTERNAL',
  DHLExternal = 'DHL_EXTERNAL',
  IMATRA = 'IMATRA',
}

export enum ApiAuthMethod {
  ApiKey = 'API_KEY',
  Basic = 'BASIC',
  OAUTH2 = 'OAUTH2',
}

export enum ApiConnectionFilterName {
  Name = 'name',
  ContactEmail = 'contactEmail',
  AuthMethod = 'authMethod',
  ConnectionType = 'connectionType',
  PartnerType = 'partnerType',
  PartnerName = 'partnerName',
}

export const API_CONNECTION_FILTER_TYPE_BY_NAME: Map<ApiConnectionFilterName, DraggableFilterType> = new Map([
  [ApiConnectionFilterName.Name, DraggableFilterType.Input],
  [ApiConnectionFilterName.ContactEmail, DraggableFilterType.Input],
  [ApiConnectionFilterName.AuthMethod, DraggableFilterType.DropDownSelect],
  [ApiConnectionFilterName.ConnectionType, DraggableFilterType.DropDownSelect],
  [ApiConnectionFilterName.PartnerName, DraggableFilterType.Input],
  [ApiConnectionFilterName.PartnerType, DraggableFilterType.DropDownSelect],
]);
export const API_CONNECTION_FILTER_SELECT_OPTIONS_BY_NAME = new Map<ApiConnectionFilterName, string[]>([
  [ApiConnectionFilterName.AuthMethod, Object.values(ApiAuthMethod)],
  [ApiConnectionFilterName.ConnectionType, Object.values(ApiConnectionType)],
  [ApiConnectionFilterName.PartnerType, Object.values(PartnerTypeAlias)],
]);

export enum ApiConnectionAssignmentType {
  PartnerAssigned = 'PARTNER_ASSIGNED',
  PartnerNotAssigned = 'PARTNER_NOT_ASSIGNED',
}

export const API_CONNECTION_FILTER_COLOR = new Map<ApiConnectionAssignmentType, StatusLabelColor>([
  [ApiConnectionAssignmentType.PartnerAssigned, StatusLabelColor.Green],
  [ApiConnectionAssignmentType.PartnerNotAssigned, StatusLabelColor.Red],
]);
export class ApiConnectionFilterModelBase {
  //statisticFilter?: ApiConnectionAssignmentType = null;
  [ApiConnectionFilterName.Name]: string = null;
  [ApiConnectionFilterName.ContactEmail]: string = null;
  [ApiConnectionFilterName.AuthMethod]: ApiAuthMethod[] = null;
  [ApiConnectionFilterName.ConnectionType]: ApiConnectionType[] = null;
  [ApiConnectionFilterName.PartnerName]: string = null;
  [ApiConnectionFilterName.PartnerType]: [] = null;

  constructor(params?: ApiConnectionFilterModelBase) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
export class ApiConnectionFilterForm {
  constructor(
    model: ApiConnectionFilterModelBase,

    public name: ControlProperty<string> = [model.name, []],
    public contactEmail: ControlProperty<string> = [model.contactEmail, []],
    public authMethod: ControlProperty<ApiAuthMethod[]> = [model.authMethod, []],
    public connectionType: ControlProperty<ApiConnectionType[]> = [model.connectionType, []],
    public partnerName: ControlProperty<string> = [model.partnerName, []],
    public partnerType: ControlProperty<PartnerTypeAlias[]> = [model.partnerType, []],
  ) {}
}
